import { useMemo } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import LogoWebInverted from "@content/images/logo-web-inverted.png"
import { resources } from "@constants/hardcoded-strings";
import { DASHBOARD_URL } from "@constants/routes";
import { getNavigationItemsForPermissions } from "@utils/navigation-menu-util";
import { IDWSession } from "@idw-types/data/idw-session";
import { AppVersion } from "../app-version/app-version";
import { NavigationMenuListContainer } from "./navigation-menu-list-container/navigation-menu-list-container";
import styles from "./navigation-menu.less";

type NavigationMenuProps = {
    session: IDWSession
    isNavigationMenuCollapsed: boolean;
    setIsNavigationMenuCollapsed: (isCollapsed: boolean) => void;
};

export const NavigationMenu = (props: NavigationMenuProps) => {
    const { session, isNavigationMenuCollapsed, setIsNavigationMenuCollapsed } = props;

    const handleCollapseHorizontallyClick = () => {
        setIsNavigationMenuCollapsed(!isNavigationMenuCollapsed);
    };

    const handleExpandVerticallyClick = () => {
        if (isNavigationMenuCollapsed) {
            setIsNavigationMenuCollapsed(false);
        }
    };

    const collapseListItem = useMemo(() => {
        return {
            title: isNavigationMenuCollapsed ? resources.common.expand : resources.common.collapse,
            idSuffix: "collapse",
            icon: isNavigationMenuCollapsed ? faArrowRight : faArrowLeft
        };
    }, [isNavigationMenuCollapsed]);

    const additionalClassName = useMemo(() => {
        return isNavigationMenuCollapsed ? styles.collapsedNavigationMenu : "";
    }, [isNavigationMenuCollapsed]);

    const availableNavigationMenuItems = useMemo(() => {
        if (session.userPermissions) {
            return getNavigationItemsForPermissions(session.userPermissions);
        } else {
            return [];
        }
    }, [session.userPermissions, session.user]);

    const fixedLogoWeb = LogoWebInverted.split("assets").join("/assets");

    return (
        <nav className={classNames(styles.navigationMenu, additionalClassName)}>
            <div className={styles.iconContainer}>
                <Link
                    id={`iddataweb-header-logo`}
                    title={"Go to Dashboard"}
                    className={styles.iconAnchor}
                    to={DASHBOARD_URL}>
                    <img src={fixedLogoWeb} alt="iddataweb logo" />
                </Link>
            </div>
            <div className={styles.collapseButton} onClick={handleCollapseHorizontallyClick}>
                <NavigationMenuListContainer
                    collapsedHorizontally={isNavigationMenuCollapsed}
                    item={collapseListItem}
                    depthLevel={0}
                    handleExpandVerticallyClick={handleExpandVerticallyClick}
                />
            </div>
            {availableNavigationMenuItems.map(item => (
                <NavigationMenuListContainer
                    key={`nav-menu-list-container-${item.title}`}
                    collapsedHorizontally={isNavigationMenuCollapsed}
                    item={item}
                    depthLevel={0}
                    handleExpandVerticallyClick={handleExpandVerticallyClick}
                />
            ))}
            {session && !isNavigationMenuCollapsed && (
                <div className={styles.userContainer}>
                    <label>Logged in as:</label>
                    <label id={"nav-menu-email-label"}>{session.user?.axnAdminUserDetails?.email || ""}</label>
                </div>
            )}
            <AppVersion showFullText={!isNavigationMenuCollapsed} />
        </nav>
    )
};